import { PlayerSizesTypes } from '../../../common/store/store.types';
import { isEmpty } from '../../../common/utils/utils';
import { removeHighlights } from '../styles';

interface StylesObject {
  playButtonStyle: { [key: string]: any };
  pauseButtonStyle: { [key: string]: any };
  containerStyle: { [key: string]: any };
}

const playPauseButtonSizeStyle = {
  extraSmall: {
    width: '30px',
    height: '30px',
    position: 'unset',
    transform: 'none',
  },
  small: {
    width: '40px',
    height: '40px',
  },
  medium: {
    width: '66px',
    height: '66px',
  },
  large: {
    width: '80px',
    height: '80px',
  },
  extraLarge: {
    width: '80px',
    height: '80px',
  },
};

const getPlayPauseButtonStyle = (playerSize: PlayerSizesTypes, clickToPlay: boolean,
  showPlayButton: boolean, showPauseButton:boolean, splitViewRatio: number, hideBlurPlayPause: boolean,
  showAdControls: boolean, viewDisplay: boolean) => {
  let style = {};
  style = {
    display: 'none',
    pointerEvents: 'none',
  };
  const sizesWithCircleButton = playerSize === 'extraSmall' || playerSize === 'small'
  || (playerSize === 'medium' && (isEmpty(splitViewRatio) || showAdControls));
  if (showPauseButton && (sizesWithCircleButton || viewDisplay)) {
    style = { ...style,
      cursor: 'pointer',
      position: 'absolute',
      display: 'inline-block',
      pointerEvents: 'all',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '100%',
      backdropFilter: 'blur(3px)',
      zIndex: 1,
    };
  } else if (clickToPlay || (showPlayButton && (sizesWithCircleButton || viewDisplay))) {
    style = { ...style,
      cursor: 'pointer',
      position: 'absolute',
      display: 'inline-block',
      pointerEvents: 'all',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '100%',
      backdropFilter: 'blur(3px)',
      zIndex: 1,
    };
  }
  style = { ...style, ...playPauseButtonSizeStyle[playerSize] };

  if (!isEmpty(splitViewRatio)) {
    if (sizesWithCircleButton) {
      style = { ...style,
        left: `${splitViewRatio / 2}%`,
      };
    }
    switch (playerSize) {
      case 'extraSmall':
      case 'small':
        style = { ...style,
          width: '32px',
          height: '32px',
        };
        break;
      case 'medium':
        style = { ...style,
          width: '44px',
          height: '44px',
        };
        break;
      default:
        break;
    }
  }

  if (hideBlurPlayPause) {
    style = { ...style,
      display: 'none',
      pointerEvents: 'none',
    };
  }

  return style;
};

export const getCirclePlayPauseButtonStyleObject = (playerSize: PlayerSizesTypes, clickToPlay: boolean,
  showPlayButton: boolean, showPauseButton: boolean, splitViewRatio: number, hideBlurPlayPause: boolean, showAdControls: boolean, viewDisplay: boolean): StylesObject => {
  return ({
    containerStyle: [
      removeHighlights,
    ],
    playButtonStyle: [
      getPlayPauseButtonStyle(playerSize, clickToPlay,
        showPlayButton, showPauseButton, splitViewRatio, hideBlurPlayPause,
        showAdControls, viewDisplay),
    ],
    pauseButtonStyle: [
      getPlayPauseButtonStyle(playerSize, clickToPlay,
        showPlayButton, showPauseButton, splitViewRatio, hideBlurPlayPause,
        showAdControls, viewDisplay),
    ],
  });
};
